<mat-icon  class="icon-display" *ngIf="notAffectOnOtherControl" color="accent">
  sync_disabled
</mat-icon>
<span  class="icon-display" *ngIf="Exists" color="accent" data-toggle="tooltip" [appInformation]="label" [imgSrc]="ImgSrc" (mouseenter)="mouseenter()">
  <span class="info_outline"></span>
</span>


<mat-icon  class="icon-display" *ngIf="!Exists">
 
</mat-icon>


